var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"audio-page"},[_c('div',{staticClass:"audio-page-body"},[_c('audio-player',{ref:"audioPlay",attrs:{"src":_vm.aduio_src}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }